(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["stock-shipping-status"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('stock-shipping-status')) {
    customElements.define(
      'stock-shipping-status',
      class StockShippingStatus extends HTMLElement {
        connectedCallback() {
          const output = this.querySelector('[data-shipping-date]');
          const processingDays = Number.parseInt(this.dataset.processingDays, 10) || 0;
          const prefix = this.dataset.shippingPrefix || '';
          const locale = this.dataset.dateLocale || 'en';
          const shippingDate = new Date();
          let daysAdded = 0;

          while (daysAdded < processingDays) {
            shippingDate.setDate(shippingDate.getDate() + 1);
            const weekday = shippingDate.getDay();
            if (weekday !== 0 && weekday !== 6) daysAdded += 1;
          }

          const formattedDate = new Intl.DateTimeFormat(locale, {
            weekday: 'short',
            month: 'short',
            day: 'numeric',
          }).format(shippingDate);

          if (output) output.textContent = `${prefix} ${formattedDate}`.trim();
        }
      }
    );
  }
  } catch(e) { console.error(e); }
})();

})();
